import * as React from 'react'
import { Button } from '../../atoms/button/button'
import { LayoutModalMessage } from '../layout-modal-message/layout-modal-message'
import ValidKeyCharacter from '../../../assets/images/valid-key-character.svg'
import SuccessIcon from '../../../assets/images/success-icon.svg'
import './modal-valid-key.scss'

export const ModalValidKey = ({ handleFinish, handleSubmit }) => {
  return (
    <LayoutModalMessage
      className="f-modal-valid-key"
      headerImage={{ url: ValidKeyCharacter, description: 'character image' }}
      icon={{ url: SuccessIcon, description: 'success icon' }}
      title="CLAVE REGISTRADA"
      description={
        <>
          <strong>La clave que ingresaste fue registrada exitosamente.</strong>{' '}
          <b>¡Recuerda guardar tus empaques!</b> De lo contrario no podrás
          reclamar tu premio y además, con tu ayuda Nosotras reciclamos,
          reducimos y reutilizamos por un planeta más sostenible.
        </>
      }
      buttons={
        <>
          <Button
            color="pink"
            type="submit"
            action={() =>{
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interacciones - Registra Otra Clave',
                category: 'cole challenge',
                action: 'click',
                label: 'registra otra clave',
              })
              handleSubmit()
            }
          }
            text="REGISTRA OTRA CLAVE"
            className="f-modal-valid-key__button"
          />
          <Button
            color="blue"
            type="submit"
            text="FINALIZAR"
            action={()=>{
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interacciones - Clave Registrada',
                category: 'cole challenge',
                action: 'click',
                label: 'finalizar',
              })
              handleFinish()
            }
          }
            className="f-modal-valid-key__button"
          />
        </>
      }
    />
  )
}
